const TypeFilterEnum = {
  NORMAL: 1,
  WITHOUTBALANCE: 2,
  ONECLIENT: 3,
};

export default TypeFilterEnum;
